import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HashRouter, Route, Routes } from 'react-router-dom';
// import './Assets/css/vendor.css';
import './Assets/css/bootstrap.css';
import './Assets/css/perfect-scrollbar.css';
import './Assets/css/style.css';
import './Assets/css/skin.css';
import './Assets/css/custom.css';
import 'react-toastify/dist/ReactToastify.css';
import Login from './Pages/Login';
import ForgotPassword from './Pages/ForgotPassword';
import Register from './Pages/Register';
import { ToastContainer } from 'react-toastify';
import Terms from './Pages/terms';
import Policy from './Pages/privacypolicy';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <ToastContainer />
    <Routes>
      <Route path='/*' element={<App />} />
      <Route path='/' element={<Login />} />
      <Route path='/terms' element={<Terms />} />
      <Route path='/privacypolicy' element={<Policy />} />
      <Route path='/login' element={<Login />} />
      <Route path='/forgotpassword' element={<ForgotPassword />} />
      <Route path='/register' element={<Register />} />
      <Route path='/register/:sponsorid' element={<Register />} />
    </Routes>
  </HashRouter>
);
